// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Migration_MigrarOsInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract de POST /migration/os/migrar-todas
 * (controllers/migration/os.php::migrar_todas).
 *
 * A franquia e obrigatoria; o periodo, opcional nos dois extremos (decisao
 * 43). A carga varre as paginas das QUATRO listas sozinha (cursor de ID) — o
 * operador nao pagina, so escolhe o recorte.
 *
 * Tipo ESTRITO pelo motivo de sempre: o id da unidade tem 19 digitos e e
 * MAIOR que 2^53 — um numero JSON aqui ja chegaria corrompido do navegador
 * (armadilha A1). As datas seguem a mesma regra por consistencia: string, ou
 * o pedido e recusado.
 *
 * As REGRAS de validacao sao as MESMAS do pre-voo, e vem de la
 * (`Migration_PreflightOsInput::validarUnidadeEPeriodo`): um periodo que a
 * tela mostra no pre-voo tem de ser aceito pela carga, sempre.
 */
import { registerContract } from './validate'

export interface Migration_MigrarOsInput {
zoho_id_unidade?: string
data_ini?: string
data_fim?: string
ids?: string
}

registerContract('Migration_MigrarOsInput', {
  zoho_id_unidade: { type: 'string',  required: false },
  data_ini:        { type: 'string',  required: false },
  data_fim:        { type: 'string',  required: false },
  ids:             { type: 'string',  required: false },
})
